import axios from './axios'

/**
 * Belépés a PÁCIENS portálra.
 *
 * ⚠️ Szándékosan külön szolgáltatás a dolgozói `auth.js`-től. A portál korábban a közös
 * `POST /login`-t hívta, aminek a guardja a dolgozói `users` táblát nézi — egy páciens
 * sosem jutott be a saját portáljára. Egy űrlap mögé két személyazonosság-teret tenni nem
 * is volna szabad: ugyanaz a cím mindkét táblában létezhet.
 */
function portalAuthService() {

    function csrf() {
        return axios.get('csrf-cookie').then(response => response.data).catch(e => { throw e })
    }

    function login(data) {
        return axios.post('public/patients/login', data).then(response => response.data).catch(e => { throw e })
    }

    // Kétfaktoros belépés (ha a portál hostja kéri): a jelszó után, még bejelentkezés előtt.
    // A portál saját útvonalai: csak a portálon nyitott függő belépést látják.
    function twoFactorChallenge() {
        return axios.get('public/patients/two-factor/challenge').then(response => response.data)
    }

    function twoFactorSend(channel) {
        return axios.post('public/patients/two-factor/send', {channel}).then(response => response.data)
    }

    function twoFactorVerify(code) {
        return axios.post('public/patients/two-factor/verify', {code}).then(response => response.data)
    }

    function logout() {
        return axios.post('public/patients/logout').then(response => response.data).catch(e => { throw e })
    }

    /**
     * Elfelejtett jelszó — a PÁCIENS brókerén, nem a dolgozóin. A kettő külön tábla és
     * külön lejárat; a dolgozói úton egy páciens címére nem is keletkezne token.
     */
    function forgotPassword(data) {
        return axios.post('public/patients/password-link', data).then(response => response.data).catch(e => { throw e })
    }

    /**
     * Amit a páciens elérhet. Nem szerepkörökből jön — a páciensnek nincs —, hanem a
     * portál LÁTHATÓ menüpontjaiból, ugyanabban az alakban, amit a felület kérdez.
     */
    function permissions() {
        return axios.get('portal/permissions').then(response => response.data).catch(e => { throw e })
    }

    // ⚠️ Regisztráció NINCS itt: azt a `patient-registration.js` végzi, mert a
    // regisztrációs képernyőnek a cím-ellenőrzés is kell, és két kliens ugyanarra a
    // végpontra előbb-utóbb szétcsúszik. A jelszó-beállító képernyő ugyanígy közvetlenül
    // hívja a sajátját.
    return { csrf, login, logout, forgotPassword, permissions, twoFactorChallenge, twoFactorSend, twoFactorVerify }
}

export default portalAuthService
